export default __webpack_public_path__ + "locales/lv/FormGallery.json?hash=3282f382af4cc6a5f878fe7f249f4d00";